<div class="container">
    <div class="jumbotron mt-3">
      <h1>MPA Partner</h1>
      <p class="lead"></p>
      <div class="row">
        <div class="col">
          <!-- <a class="btn btn-lg btn-primary" routerLink="/register" role="button">Signup &raquo;</a> -->
          <a class="btn btn-lg btn-primary ml-4" routerLink="/login" role="button">Login &raquo;</a>
        </div>
      </div>      
</div>

 